import http, { ApiBaseUrl } from "../../http-common";

export default class StationService {

    static createInfoStation(data) {
        return http.post("/stations/create", data);
    }

    static getAllInfoStations() {
        return http.get("/stations/getAll");
    }

    static updateInfoStation(station_id, data) {
        return http.put(`/stations/update/${station_id}`, data);
    }

    static deleteInfoStation(station_id) {
        return http.delete(`/stations/delete/${station_id}`);
    }


    static copyToInputs(data) {
        return http.post("/run-documents", data);
    }

    static createMainStationFolder(data) {
        return http.post("/create-folder", data);
    }

    static getStations(path) {
        return http.get("/stations", {
            params: { path }
        });
    }

    static getStationDetails(path) {
        return http.get("/station_details", {
            params: { path }
        });
    }

    static getDashboardZones() {
        return http.get("/dashboard/zones");
    }

    // In StationService.js
    static async openFile(data, config = {}) {
        return await http.post('/open-file', data, {
            ...config,
            responseType: 'blob',  // Force blob response
            headers: {
                'Accept': '*/*'
            }
        });
    }

    static uploadInputFile(data) {
        return http.post("/upload-input-file", data);
    }


    static copyFilesToOutput(data) {
        return http.post("/copy-files", data);
    }

    static deleteFilesInOutput(data) {
        return http.post("/delete-files", data);
    }

    static checkDocuments(data) {
        return http.post("/check-documents", data);
    }


    static convertFilePath(data) {
        const formData = new FormData();
        formData.append('input_path', data.input_path);
        formData.append('output_path', data.output_path);
        formData.append('station_info_path', data.station_info_path);
        formData.append('station_name', data.station_name)

        return http.post("/convert-file", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            responseType: "blob"  // Important for downloading the file
        });
    }

    static async convertFileProgress(data, onEvent = null) {
        const formData = new FormData();
        formData.append('input_path', data.input_path);
        formData.append('output_path', data.output_path);
        formData.append('station_info_path', data.station_info_path);
        formData.append('station_name', data.station_name);
        formData.append('version', data.version);

        const response = await fetch(`${ApiBaseUrl}/convert-file-progress`, {
            method: 'POST',
            body: formData,
        });

        if (!response.ok || !response.body) {
            const errText = await response.text().catch(() => '');
            throw new Error(errText || `HTTP ${response.status}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
            const { value, done } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });

            let parts = buffer.split(/\r?\n\r?\n/);
            buffer = parts.pop() || '';

            for (const part of parts) {
                const lines = part.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
                for (const line of lines) {
                    if (!line.startsWith('data:')) continue;
                    const payload = line.replace(/^data:\s*/, '');
                    if (!payload) continue;

                    try {
                        const parsed = JSON.parse(payload);
                        onEvent?.(parsed);
                        if (parsed.status === 'error') {
                            throw new Error(parsed.error || 'Excel generation failed');
                        }
                    } catch (jsonErr) {
                        if (jsonErr instanceof Error && jsonErr.message.includes('Excel generation failed')) {
                            throw jsonErr;
                        }
                        console.warn('Invalid SSE payload:', payload, jsonErr);
                    }
                }
            }
        }

        if (buffer.trim()) {
            const lines = buffer.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
            for (const line of lines) {
                if (!line.startsWith('data:')) continue;
                const payload = line.replace(/^data:\s*/, '');
                if (!payload) continue;

                try {
                    const parsed = JSON.parse(payload);
                    onEvent?.(parsed);
                    if (parsed.status === 'error') {
                        throw new Error(parsed.error || 'Excel generation failed');
                    }
                } catch (jsonErr) {
                    if (jsonErr instanceof Error && jsonErr.message.includes('Excel generation failed')) {
                        throw jsonErr;
                    }
                    console.warn('Invalid SSE payload:', payload, jsonErr);
                }
            }
        }
    }

    static convertFileV2(data) {
        const formData = new FormData();
        formData.append('input_path', data.input_path);
        formData.append('output_path', data.output_path);
        formData.append('version', data.version);

        return http.post("/convert-file-v2", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }

    static convertToPdf(data) {
        const formData = new FormData();
        formData.append('input_path', data.input_path);
        formData.append('output_path', data.output_path);
        formData.append('station_info_path', data.station_info_path);
        formData.append('station_name', data.station_name)
        formData.append('custom_footer_template', data.custom_footer_template)

        return http.post("/generate-pdf", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            responseType: "blob"  // Important for downloading the file
        });
    }

    static async generatePdfProgress(data, onEvent = null) {
        const formData = new FormData();
        formData.append('input_path', data.input_path);
        formData.append('output_path', data.output_path);
        formData.append('station_info_path', data.station_info_path);
        formData.append('station_name', data.station_name);
        formData.append('version', data.version);

        const response = await fetch(`${ApiBaseUrl}/generate-pdf-progress`, {
            method: 'POST',
            body: formData,
        });

        if (!response.ok || !response.body) {
            const errText = await response.text().catch(() => '');
            throw new Error(errText || `HTTP ${response.status}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
            const { value, done } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });

            let parts = buffer.split(/\r?\n\r?\n/);
            buffer = parts.pop() || '';

            for (const part of parts) {
                const lines = part.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
                for (const line of lines) {
                    if (!line.startsWith('data:')) continue;
                    const payload = line.replace(/^data:\s*/, '');
                    if (!payload) continue;

                    try {
                        const parsed = JSON.parse(payload);
                        onEvent?.(parsed);
                        if (parsed.status === 'error') {
                            throw new Error(parsed.error || 'PDF generation failed');
                        }
                    } catch (jsonErr) {
                        if (jsonErr instanceof Error && jsonErr.message.includes('PDF generation failed')) {
                            throw jsonErr;
                        }
                        console.warn('Invalid SSE payload:', payload, jsonErr);
                    }
                }
            }
        }

        if (buffer.trim()) {
            const lines = buffer.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
            for (const line of lines) {
                if (!line.startsWith('data:')) continue;
                const payload = line.replace(/^data:\s*/, '');
                if (!payload) continue;

                try {
                    const parsed = JSON.parse(payload);
                    onEvent?.(parsed);
                    if (parsed.status === 'error') {
                        throw new Error(parsed.error || 'PDF generation failed');
                    }
                } catch (jsonErr) {
                    if (jsonErr instanceof Error && jsonErr.message.includes('PDF generation failed')) {
                        throw jsonErr;
                    }
                    console.warn('Invalid SSE payload:', payload, jsonErr);
                }
            }
        }
    }

    static generatePdfFromImage(data) {
        const formData = new FormData();
        formData.append('image_path', data.image_path);
        formData.append('output_path', data.output_path);
        formData.append('tag_data_path', data.tag_data_path);
        formData.append('station_info_path', data.station_info_path);
        formData.append('station_name', data.station_name);
        formData.append('version', data.version);

        return http.post("/generate-rfid-pdf", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }


    static generateTocPdf(data) {
        const formData = new FormData();
        formData.append('input_path', data.input_path);
        formData.append('output_path', data.output_path);
        formData.append('station_info_path', data.station_info_path);
        formData.append('station_name', data.station_name)
        formData.append('ser_first_signature', data.ser_first_signature)
        formData.append('ser_second_signature', data.ser_second_signature)

        return http.post("/generate-toc-pdf", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            responseType: "blob"
        });
    }

    static async generateTocPdfProgress(data, onEvent = null) {
        const formData = new FormData();
        formData.append('input_path', data.input_path);
        formData.append('output_path', data.output_path);
        formData.append('station_info_path', data.station_info_path);
        formData.append('station_name', data.station_name);
        formData.append('version', data.version);
        formData.append('ser_first_signature', data.ser_first_signature || '');
        formData.append('ser_second_signature', data.ser_second_signature || '');

        const response = await fetch(`${ApiBaseUrl}/generate-toc-pdf-progress`, {
            method: 'POST',
            body: formData,
        });

        if (!response.ok || !response.body) {
            const errText = await response.text().catch(() => '');
            throw new Error(errText || `HTTP ${response.status}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
            const { value, done } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });

            let parts = buffer.split(/\r?\n\r?\n/);
            buffer = parts.pop() || '';

            for (const part of parts) {
                const lines = part.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
                for (const line of lines) {
                    if (!line.startsWith('data:')) continue;
                    const payload = line.replace(/^data:\s*/, '');
                    if (!payload) continue;

                    try {
                        const parsed = JSON.parse(payload);
                        onEvent?.(parsed);
                        if (parsed.status === 'error') {
                            throw new Error(parsed.error || 'TOC generation failed');
                        }
                    } catch (jsonErr) {
                        if (jsonErr instanceof Error && jsonErr.message.includes('TOC generation failed')) {
                            throw jsonErr;
                        }
                        console.warn('Invalid SSE payload:', payload, jsonErr);
                    }
                }
            }
        }

        if (buffer.trim()) {
            const lines = buffer.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
            for (const line of lines) {
                if (!line.startsWith('data:')) continue;
                const payload = line.replace(/^data:\s*/, '');
                if (!payload) continue;

                try {
                    const parsed = JSON.parse(payload);
                    onEvent?.(parsed);
                    if (parsed.status === 'error') {
                        throw new Error(parsed.error || 'TOC generation failed');
                    }
                } catch (jsonErr) {
                    if (jsonErr instanceof Error && jsonErr.message.includes('TOC generation failed')) {
                        throw jsonErr;
                    }
                    console.warn('Invalid SSE payload:', payload, jsonErr);
                }
            }
        }
    }



    // ================= VERIFICATION APIs ==================

    static verifyIssue(recordId, remarks) {
        return http.post(`/verification/verify-issue/${recordId}`, { remarks });
    }

    static verifyStation(station, version, verified_by, remarks) {
        return http.post("/verification/verify-station", {
            station,
            version,
            verified_by,
            remarks
        });
    }

    static raiseFlag(station, version, verified_by, remarks) {
        return http.post("/verification/raise-flag", {
            station,
            version,
            verified_by,
            remarks
        });
    }

    static getVerificationRecords(stationName, version) {
        return http.get(`/verification/records/${stationName}/${version}`);
    }

    // ================= INPUT FILE UPLOAD ==================

    static uploadInputFileAuto(file, station, base_path) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("station", station);
        formData.append("base_path", base_path);

        return http.post("/upload-input-file", formData);
    }

    // ================= Versions ==================
    static getStationVersions(stationName) {
        return http.get(`/versions/getByStation/${stationName}`);
    }

    static createStationVersion(station, version) {
        return http.post("/versions/create-custom", {
            station,
            version
        });
    }


}